<template>
  <keep-alive>
    <router-view></router-view>
  </keep-alive>
</template>

<style>
html,body {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  background-color: #f0f2f5;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  overflow: hidden;
}
</style>

<script>
export default {
  name: 'App',
  mounted () {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue